import React from "react";

function CloudSecurity() {
  return <h2>Cloud Security Services</h2>;
}

export default CloudSecurity;
